import type { SeasonState } from '@protector/entities/season/models';
import type { Selector } from 'core/core.selectors';

export const getSeasonEntitiesInEntities: Selector<SeasonState['entities']> = state => state.entities.season.entities;
